import { createSlice } from "@reduxjs/toolkit";
import { SliceAction } from "store/store";

const queryParamsLS = JSON.parse(window.localStorage.getItem("adminCustomersHistoryPage") || "{}");
const queryParamsURL = Object.fromEntries(new URLSearchParams(window.location.search));

const isActivePage = window.location.pathname.includes("customers") && (queryParamsURL?.tab === "history")

const initialState: {
    activePaginationPage: number,
    activePaginationLimit: number,
} = Object.assign(
    (isActivePage && Object.keys(queryParamsURL).some(item => ["page", "limit"].includes(item)))
        ? {
            activePaginationPage: Number(queryParamsURL?.page || "1"),
            activePaginationLimit: Number(queryParamsURL?.limit || "50"),
        }
        : {
            activePaginationPage: 1, // A page saved for another client is not valid here.
            activePaginationLimit: Number(queryParamsLS?.limit || "50"),
        }
);

window.localStorage.setItem("adminCustomersHistoryPage", JSON.stringify({
    page: initialState.activePaginationPage,
    limit: initialState.activePaginationLimit,
}))

const customerHistorySlice = createSlice({
    initialState,
    name: "customerHistoryAdminPage",
    reducers: {
        setActivePaginationPage(state, action: SliceAction<(typeof initialState)["activePaginationPage"]>) {
            window.localStorage.setItem("adminCustomersHistoryPage", JSON.stringify({
                page: action.payload,
                limit: state.activePaginationLimit,
            }))
            state.activePaginationPage = action.payload;
        },
        setActivePaginationLimit(state, action: SliceAction<(typeof initialState)["activePaginationLimit"]>) {
            window.localStorage.setItem("adminCustomersHistoryPage", JSON.stringify({
                page: 1,
                limit: action.payload,
            }))
            state.activePaginationPage = 1;
            state.activePaginationLimit = action.payload;
        },
    },
});

const { reducer, actions } = customerHistorySlice;

export default reducer;

export const {
    setActivePaginationLimit,
    setActivePaginationPage
} = actions;
